import React from 'react';
import PropTypes from 'prop-types';
import refresh from '../jsx/Refresh.jsx';
import { getStateMessage, REFRESH_INTERVAL } from './common.jsx';
import { StoreAvailability, State } from '../../../storeavailability';

/**
 * Dynamic store status message (changing with time) used in the stock checker
 * static states (eg not in stock, pick up only) are inserted directly in CollectInStoreItem,
 * this component is not used
 * @param openingHours opening hours array as returned by the stock checker call
 * @param currentDate object representing current date
 */
function ProductPageState({ openingHours, currentDate }) {
  const storeAvailability = new StoreAvailability({
    openHours: openingHours,
    currentDate: currentDate
  });
  const storeState = storeAvailability.getOpenState();
  const nextOpenDay = storeAvailability.getNextOpenDay();
  const classNames = [];
  const componentTranslationsPrefix = 'component.mcd';

  if (nextOpenDay && nextOpenDay.offset === 1 && storeState === State.CLOSED) {
    classNames.push('smaller');
  }

  return (
    <span className={classNames.join(' ')}>
      {getStateMessage(storeAvailability, componentTranslationsPrefix)}
    </span>
  );
}

export default refresh(ProductPageState, REFRESH_INTERVAL);

ProductPageState.propTypes = {
  openingHours: PropTypes.arrayOf(PropTypes.shape({
    closeMinutes: PropTypes.number,
    day: PropTypes.string,
    openMinutes: PropTypes.number,
    order: PropTypes.number
  })).isRequired,
  currentDate: PropTypes.objectOf(Date).isRequired
};
